import React, { useState } from 'react';
import './login.css';
import { Link, useNavigate } from 'react-router-dom';
import api from '../../services/api';
import WelcomeScreen from '../loading/WelcomeScreen';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

function Login({ onLogin }) {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [errors, setErrors] = useState({});
    const [showWelcome, setShowWelcome] = useState(false);
    const [userName, setUserName] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();

    const validate = () => {
        const newErrors = {};

        // Email: Regex simples
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!email) {
            newErrors.email = 'O email é obrigatório.';
        } else if (!emailRegex.test(email)) {
            newErrors.email = 'Digite um email válido.';
        }

        // Senha: Obrigatória
        if (!password) {
            newErrors.password = 'A senha é obrigatória.';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setErrors({});

        if (!validate()) {
            return;
        }

        try {
            const response = await api.post('/auth/login', { email, password });
            const { token, name, role } = response.data;

            localStorage.setItem('token', token);
            localStorage.setItem('userName', name);
            localStorage.setItem('userRole', role);
            setUserName(name);

            // Show welcome screen instead of immediate redirect
            setShowWelcome(true);

            setTimeout(() => {
                onLogin();
                navigate('/plataforma');
            }, 2500);

        } catch (err) {
            console.error(err);
            setError('Email ou senha incorretos!');
        }
    };

    if (showWelcome) {
        return <WelcomeScreen name={userName} />;
    }

    return (
        <div className="auth-container">
            <img src={require('../../assets/logos/Logo.png')} alt="Sulash" className="logo-header" />
            <div className="auth-form">
                <h2>Login</h2>
                {error && <p className="error-msg" style={{ color: 'red' }}>{error}</p>}
                <form onSubmit={handleSubmit}>
                    <div className="input-group">
                        <input
                            type="email"
                            id="email"
                            placeholder=" "
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                        <label htmlFor="email">Email</label>
                        {errors.email && <span style={{ color: 'red', fontSize: '0.8rem', display: 'block', marginTop: '5px', textAlign: 'left' }}>{errors.email}</span>}
                    </div>
                    <div className="input-group">
                        <div style={{ position: 'relative' }}>
                            <input
                                type={showPassword ? "text" : "password"}
                                id="password"
                                placeholder=" "
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                            <label htmlFor="password">Senha</label>
                            <span
                                onClick={() => setShowPassword(!showPassword)}
                                style={{
                                    position: 'absolute',
                                    right: '10px',
                                    top: '10px',
                                    cursor: 'pointer',
                                    color: '#fff'
                                }}
                            >
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </span>
                        </div>
                        {errors.password && <span style={{ color: 'red', fontSize: '0.8rem', display: 'block', marginTop: '5px', textAlign: 'left' }}>{errors.password}</span>}
                    </div>
                    <button type="submit" className="auth-button">Entrar</button>
                </form>
                <div className="auth-link">
                    <p>Não tem uma conta? <Link to="/cadastro">Cadastre-se</Link></p>
                </div>
            </div>
        </div>
    );
}

export default Login;